import type { CheckoutSessionsResponse } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';
import {
  getAgent,
  getCollectionDetailsTel,
  getMerchantConsentID,
  getMerchantConsentText,
} from '../../../utils/session/selectors';
import { getCurrentTimeStamp } from '../../../utils/date/getCurrentTimeStamp';
import { getUserAgent } from '../../../utils/browser/getUserAgent';
import type {
  ConsentObject,
  HowConsentCollected,
} from '../types/ConsentObject';

export type { ConsentObject, HowConsentCollected };

export const createConsentCollectionDetails = (
  session: CheckoutSessionsResponse,
): ConsentObject['collectionDetails'] => {
  const consentCollectionType = getAgent(session)
    ? 'tel'
    : 'web';
  if (consentCollectionType === 'tel') {
    const collectionDetailsTel =
      getCollectionDetailsTel(session);
    return {
      type: 'TEL',
      tel: {
        inboundPhoneNumber: {
          countryCode:
            collectionDetailsTel?.tel.inboundPhoneNumber
              .countryCode || '',
          number:
            collectionDetailsTel?.tel.inboundPhoneNumber
              .number || '',
        },
      },
    };
  }
  return {
    type: 'WEB',
    web: {
      ipAddress: null,
      userAgent: getUserAgent(),
    },
  };
};

export const createConsentObject = (
  session: CheckoutSessionsResponse,
): ConsentObject => {
  return {
    merchantConsentId: getMerchantConsentID(session),
    merchantConsentText: getMerchantConsentText(session),
    collectionTimestamp: getCurrentTimeStamp(),
    collectionDetails: createConsentCollectionDetails(session),
  };
};
